/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum SalesPipelineStage {
  Unknown = "unknown",
  Disqualified = "disqualified",
  Lead = "lead",
  NeverQuoted = "never_quoted",
  QuotedNeverBooked = "quoted_never_booked",
  Booked1To4 = "booked_1_to_4",
  RegularShipper = "regular_shipper",
}

export function instanceOfSalesPipelineStage(value: any): boolean {
  for (const key in SalesPipelineStage) {
    if (Object.prototype.hasOwnProperty.call(SalesPipelineStage, key)) {
      if (
        SalesPipelineStage[key as keyof typeof SalesPipelineStage] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function SalesPipelineStageFromJSON(json: any): SalesPipelineStage {
  return SalesPipelineStageFromJSONTyped(json, false);
}

export function SalesPipelineStageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SalesPipelineStage {
  return json as SalesPipelineStage;
}

export function SalesPipelineStageToJSON(
  value?: SalesPipelineStage | null,
): any {
  return value as any;
}

export function SalesPipelineStageToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): SalesPipelineStage {
  return value as SalesPipelineStage;
}
